import { createContext } from 'react'
import UMath, { Clock } from '../utils/umath'

export interface IClockContext {
  time: Clock
}

const ClockContext = createContext<IClockContext>({ time: UMath.clock() })

export default ClockContext
